import type { FeedbackConversationTarget } from './types';

const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Both identifiers are required; a selected roster player never substitutes
 * for an absent child identity in a shared link. Authorization stays server-side. */
export function feedbackNavigationTarget(search: Record<string, unknown>): FeedbackConversationTarget | null {
  const feedbackId = search.feedback_id, playerId = search.feedback_player_id;
  return typeof feedbackId === 'string' && uuid.test(feedbackId)
    && typeof playerId === 'string' && playerId.length > 0 && playerId.length <= 200
    ? { feedbackId, playerId } : null;
}

export function feedbackNavigationSearch(target: FeedbackConversationTarget) {
  return { feedback_id: target.feedbackId, feedback_player_id: target.playerId };
}
